// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Currency from "./Currency.bs.js";
import * as CurrencyMinor from "./CurrencyMinor.bs.js";

function currencyToBase(a) {
  var r = Currency.fromCurrency(a);
  return CurrencyMinor.toBase(r * 100.0 | 0);
}

function baseToCurrency(a) {
  var p = CurrencyMinor.fromBase(a);
  return Currency.toCurrency(p / 100.0);
}

export {
  currencyToBase ,
  baseToCurrency ,
  
}
/* No side effect */
